
import { defineComponent } from 'vue'
import CreateRepositoryGroup from '~/apollo/mutations/group/CreateRepositoryGroup.gql'
import ownerDetailMixin from '~/mixins/ownerDetailMixin'
import type { GraphqlMutationResponse } from '~/types/apolloTypes'

export default defineComponent({
  name: 'CreateRepoGroupModal',
  mixins: [ownerDetailMixin],
  data() {
    return {
      groupName: '',
      submitting: false
    }
  },
  computed: {
    isValid() {
      return this.groupName.trim().length > 0
    },
    preventClose() {
      return this.submitting
    }
  },
  methods: {
    closeModal() {
      if (this.preventClose) return
      this.$emit('close')
    },
    async createGroup() {
      if (!this.isValid) return
      this.submitting = true

      try {
        const response: GraphqlMutationResponse = await this.$applyGraphqlMutation(
          CreateRepositoryGroup,
          {
            ownerId: this.owner.id,
            name: this.groupName.trim()
          }
        )
        if (response.data?.createRepositoryGroup?.ok) {
          this.$toast.success('Repository group created successfully')
          this.$emit('group-created')
          this.submitting = false
          this.closeModal()
        } else {
          this.$logErrorAndToast(
            new Error(
              response.errors?.map((e) => e.message).join(', ') ??
                'API error or unsuccessful update.'
            ),
            'Failed to create repository group.'
          )
        }
      } catch (e) {
        this.$logErrorAndToast(e as Error, 'Failed to create repository group.')
      }

      this.submitting = false
    }
  }
})
